"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Popover = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactPopper = require("react-popper");

var _classnames = _interopRequireDefault(require("classnames"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var Popover = function Popover(_ref) {
  var children = _ref.children,
      referenceElement = _ref.referenceElement,
      onClick = _ref.onClick,
      onBackgroundClick = _ref.onBackgroundClick,
      classNames = _ref.classNames,
      isVisible = _ref.isVisible,
      isWarning = _ref.isWarning,
      isError = _ref.isError,
      isSuccess = _ref.isSuccess,
      menuPlacement = _ref.menuPlacement,
      defaultOpen = _ref.defaultOpen;
  var popperRef = (0, _react.useRef)();

  var _useState = (0, _react.useState)(defaultOpen),
      _useState2 = _slicedToArray(_useState, 2),
      isPopoverVisible = _useState2[0],
      setIsPopoverVisible = _useState2[1];

  var handleBackgroundClick = function handleBackgroundClick() {
    if (isVisible === undefined) {
      setIsPopoverVisible(false);
    }

    if (onBackgroundClick) {
      onBackgroundClick();
    }
  };

  var outsideClickListenerRef = (0, _react.useRef)(function (event) {
    if (popperRef.current && !popperRef.current.contains(event.target)) {
      handleBackgroundClick();
    }
  });
  (0, _react.useEffect)(function () {
    // add when mounted
    document.addEventListener('mousedown', outsideClickListenerRef.current); // return function to be called when unmounted

    return function () {
      document.removeEventListener('mousedown', outsideClickListenerRef.current);
    };
  }, []);

  var togglePopperVisibility = function togglePopperVisibility() {
    var nextVisibility = !isPopoverVisible;

    if (isVisible === undefined) {
      setIsPopoverVisible(nextVisibility);
    }

    if (onClick) {
      onClick();
    }
  };

  var shouldShowPopover = isVisible !== undefined ? isVisible : isPopoverVisible; // ADA compliant - allow an enter key to act like a click.

  var _handleKeyPress = function _handleKeyPress(target) {
    if (target.key === 'Enter') {
      target.currentTarget.click();
    }
  };

  var popperRefClassNames = (0, _classnames.default)({
    'popover__ref-element': true,
    'popover__ref-element--open': isPopoverVisible
  });
  var popoverContentClassnames = (0, _classnames.default)('popover__content', {
    'popover__content--warning': isWarning,
    'popover__content--success': isSuccess,
    'popover__content--error': isError
  });
  var popoverArrowClassnames = (0, _classnames.default)('popover__arrow', {
    'popover__arrow--warning': isWarning,
    'popover__arrow--success': isSuccess,
    'popover__arrow--error': isError
  });
  return (
    /*#__PURE__*/
    // TODO
    // @ts-ignore
    _react.default.createElement("div", {
      ref: popperRef,
      className: (0, _classnames.default)(classNames, 'popover')
    }, /*#__PURE__*/_react.default.createElement(_reactPopper.Manager, null, /*#__PURE__*/_react.default.createElement(_reactPopper.Reference, null, function (_ref2) {
      var ref = _ref2.ref;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: popperRefClassNames,
        role: "button",
        tabIndex: 0,
        ref: ref,
        onClick: function onClick(e) {
          e.stopPropagation();
          togglePopperVisibility();
        },
        onKeyDown: _handleKeyPress,
        "aria-label": "Click to open menu"
      }, referenceElement);
    }), shouldShowPopover ? /*#__PURE__*/_react.default.createElement(_reactPopper.Popper, {
      placement: menuPlacement,
      eventsEnabled: false,
      modifiers: {
        data: {
          arrowStyles: {
            padding: '-80px'
          }
        }
      }
    }, function (_ref3) {
      var ref = _ref3.ref,
          style = _ref3.style,
          placement = _ref3.placement,
          arrowProps = _ref3.arrowProps;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: popoverContentClassnames,
        ref: ref,
        style: style,
        "data-placement": placement
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: popoverArrowClassnames,
        ref: arrowProps.ref,
        style: arrowProps.style
      }), children);
    }) : null))
  );
};

exports.Popover = Popover;
Popover.propTypes = {
  defaultOpen: _propTypes.default.bool.isRequired,
  menuPlacement: _propTypes.default.oneOfType([_propTypes.default.oneOf(['auto-start']), _propTypes.default.oneOf(['auto']), _propTypes.default.oneOf(['auto-end']), _propTypes.default.oneOf(['top-start']), _propTypes.default.oneOf(['top']), _propTypes.default.oneOf(['top-end']), _propTypes.default.oneOf(['right-start']), _propTypes.default.oneOf(['right']), _propTypes.default.oneOf(['right-end']), _propTypes.default.oneOf(['bottom-end']), _propTypes.default.oneOf(['bottom']), _propTypes.default.oneOf(['bottom-start']), _propTypes.default.oneOf(['left-end']), _propTypes.default.oneOf(['left']), _propTypes.default.oneOf(['left-start'])]).isRequired,
  children: _propTypes.default.node.isRequired,
  referenceElement: _propTypes.default.node.isRequired,
  onClick: _propTypes.default.func,
  onBackgroundClick: _propTypes.default.func,
  classNames: _propTypes.default.any,
  isVisible: _propTypes.default.bool,
  isWarning: _propTypes.default.bool,
  isError: _propTypes.default.bool,
  isSuccess: _propTypes.default.bool
};
var defaultProps = {
  defaultOpen: false,
  menuPlacement: 'bottom'
};
Popover.defaultProps = defaultProps;
var _default = Popover;
exports.default = _default;